import Type from './Type';
export function isITranscript(track) {
    return track.type === Type.Transcript;
}
export default isITranscript;    //# sourceMappingURL=isITranscript.js.map
